export default "<div class=\"dual-level-selector\">\n</div>\n\n\n"